module.exports = function (el) {
  var $el = $(el)

  if (navigator.platform.indexOf('Win') > -1) {
    $el.addClass('windows')
  }
}
